// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
  Taken basically right from the JwmLinkedWorkspace.less
  file. I think this could be a good candidate for
  more refactoring to unify the linked projects
  and invite rows components on the workspace sidebar
  since the styles are very similar and behave
  similarly.
  */
.crYQkPJQi_eBJn {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  border-radius: 0;
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
}
.CAoPLSCT0bCbyg {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-left: var(--ds-space-150, 10px);
  border-radius: 0;
  font-weight: var(--ds-font-weight-regular, 400);
  text-decoration: none;
  background-color: transparent;
}
.CAoPLSCT0bCbyg:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 0%, 0.08));
  text-decoration: none;
}
.body-dark-board-background .CAoPLSCT0bCbyg:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
html[data-color-mode='dark'] .CAoPLSCT0bCbyg:hover {
  background-color: var(--dynamic-nav-button-background-color-hovered, hsla(0, 0%, 100%, 0.16));
}
.CAoPLSCT0bCbyg:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 0%, 0.16));
}
.body-dark-board-background .CAoPLSCT0bCbyg:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
html[data-color-mode='dark'] .CAoPLSCT0bCbyg:active {
  background-color: var(--dynamic-nav-button-background-color-pressed, hsla(0, 0%, 100%, 0.3));
}
.KpKr1jGvqonx0v {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
  color: var(--dynamic-text);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iosz0n1bHUjpGI {
  margin: var(--ds-space-0, 0) var(--ds-space-075, 6px);
  padding: var(--ds-space-050, 4px);
}
.rG51vK51GOwKh4 {
  padding: var(--ds-space-050, 4px);
}
.Cp7lMTHC_l_VEY {
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var workspaceLinkRow = `crYQkPJQi_eBJn`;
export var workspaceLink = `CAoPLSCT0bCbyg`;
export var workspaceLinkText = `KpKr1jGvqonx0v`;
export var shortcutIcon = `iosz0n1bHUjpGI`;
export var shortcutIconFlagEnabled = `rG51vK51GOwKh4`;
export var newWorkspacePage = `Cp7lMTHC_l_VEY`;
export default ___CSS_LOADER_EXPORT___;
